import React from 'react';
import ModernNavbar from '../../common/components/ModernNavbar/ModernNavbar';
import ModernHero from '../../common/components/ModernHero/ModernHero';
import ModernAbout from '../../common/components/ModernAbout/ModernAbout';
import ModernServices from '../../common/components/ModernServices/ModernServices';
import ModernTeam from '../../common/components/ModernTeam/ModernTeam';
import ModernFooter from '../../common/components/ModernFooter/ModernFooter';

const Home = () => {
  return (
    <div className="bg-dark-950">
      <ModernNavbar />
      <ModernHero />
      <ModernAbout />
      <ModernServices />
      <ModernTeam />
      <ModernFooter />
    </div>
  );
};

export default Home;
